import React from 'react';
import { Star, Quote, MapPin, ArrowRight } from 'lucide-react';
type Testimonial = {
  name: string;
  image: string;
  location: string;
  transition: string;
  quote: string;
};
const testimonials: Testimonial[] = [{
  name: 'Carlos M.',
  image: 'https://cdn.magicpatterns.com/uploads/qd93VQRUqtJdKfi2gGUWyY/testimonio_1_...png',
  location: 'Houston, Texas',
  transition: 'Construcción → estudiando IT Support',
  quote: 'Yo no sabía nada de computadoras más allá de usar el teléfono. Llevaba 6 años en construcción y honestamente ya no aguantaba más el frío en invierno y el calor en verano. Un amigo me pasó esta guía. La verdad dudé mucho porque $6 me parecía raro, pensé que era una estafa. Pero la leí completa en un fin de semana. Lo que más me ayudó fue el capítulo del currículum — nunca supe cómo poner mi experiencia en construcción en un CV americano. Hoy llevo 4 meses estudiando IT Support de Google. Todavía no cambio de trabajo pero ya tengo entrevistas. Eso antes era imposible para mí.'
}, {
  name: 'Miguel R.',
  image: 'https://cdn.magicpatterns.com/uploads/jQbqpBNAiJvKec3xzoLxH8/testimonio_2_....png',
  location: 'Dallas, Texas',
  transition: 'Almacén → cursando Data Analytics de Google',
  quote: 'Mira, yo soy de los que no creen en estas cosas de internet. Pero mi esposa me dijo que si no hacía algo diferente íbamos a seguir igual otros 10 años. Tengo 41 años, trabajo en un almacén desde hace 5, y el inglés mío es básico básico. Lo que me convenció fue la parte de Financial Aid de Coursera — no sabía que podías pedir el curso gratis. Eso solo ya pagó la guía mil veces. Estoy en el mes 2 de Data Analytics y entiendo más de lo que pensaba. Mi jefe todavía no sabe que me voy a ir.'
}, {
  name: 'Ana L.',
  image: 'https://cdn.magicpatterns.com/uploads/sPk6HCsii1wgFx9Yqvxx2k/testimonio_4....png',
  location: 'Miami, Florida',
  transition: 'Servicios de limpieza → UX Design freelance',
  quote: 'Soy mamá de dos niños y limpiaba casas de lunes a sábado. El problema no era el trabajo — es que no veía a mis hijos crecer. Cuando leí la parte de UX Design dije "esto es para mí" porque siempre me gustó el diseño pero nunca pensé que podía trabajar de eso aquí en Estados Unidos. El capítulo de inglés técnico me quitó el miedo más grande que tenía. No necesitas hablar perfecto, necesitas hablar lo necesario. Llevo 3 meses y ya tengo mi primer proyecto freelance. Pequeño, pero mío.'
}, {
  name: 'Roberto D.',
  image: 'https://cdn.magicpatterns.com/uploads/9fXFtqSyXJJqAGyn1JYPmS/testimonio_3....png',
  location: 'Chicago, Illinois',
  transition: 'Restaurante → estudiando Ciberseguridad Google',
  quote: 'Lo compré un martes en la noche después de un turno de 10 horas en el restaurante. Estaba cansado y enojado y dije "voy a leer esto y si es basura pido el reembolso". No pedí el reembolso. Lo que más me impactó fue ver la lista de empresas que contratan graduados de Google — Walmart, Verizon, Bank of America — empresas que yo veía como inalcanzables. La guía no te promete magia. Te dice exactamente qué hacer, en qué orden, y por qué. Eso es lo que necesitaba. Un mapa. No motivación. Un mapa.'
}];
export function TestimonialsSection() {
  return <section className="w-full bg-gray-50 py-16 px-4 sm:px-6 lg:px-8" data-id="element-433">
      <div className="max-w-6xl mx-auto" data-id="element-434">
        <div className="text-center mb-12" data-id="element-435">
          <div className="inline-flex items-center bg-brandGold/10 text-brandGold font-bold px-4 py-1.5 rounded-full text-sm mb-4 uppercase tracking-wider" data-id="element-436">
            <Star className="w-4 h-4 mr-2 fill-brandGold" data-id="element-437" />
            Historias Reales
          </div>
          <h2 className="text-3xl sm:text-5xl font-black text-navy mb-4" data-id="element-438">
            Hispanos como tú ya están dando el salto
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto" data-id="element-439">
            Estas son las palabras de personas que estaban exactamente donde tú
            estás hoy. Y decidieron hacer algo diferente.
          </p>

          <div className="flex items-center justify-center gap-2 mt-6" data-id="element-440">
            <div className="flex" data-id="element-441">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-6 h-6 fill-brandGold text-brandGold" data-id="element-442" />)}
            </div>
            <span className="text-navy font-bold" data-id="element-443">4.9 / 5</span>
            <span className="text-gray-500" data-id="element-444">
              — basado en compradores reales
            </span>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-445">
          {testimonials.map(t => <article key={t.name} className="bg-white rounded-2xl shadow-lg border border-gray-100 p-6 sm:p-8 flex flex-col relative overflow-hidden" data-id="element-446">
              <Quote className="absolute top-4 right-4 w-16 h-16 text-gray-100" data-id="element-447" />

              <div className="flex items-center gap-4 mb-5 relative" data-id="element-448">
                <img src={t.image} alt={`Foto de ${t.name}`} className="w-16 h-16 sm:w-20 sm:h-20 rounded-full object-cover border-4 border-white shadow-md flex-shrink-0" data-id="element-449" />
                <div data-id="element-450">
                  <h3 className="text-lg font-bold text-navy" data-id="element-451">{t.name}</h3>
                  <p className="text-sm text-gray-600 flex items-start mb-1" data-id="element-452">
                    <ArrowRight className="w-3.5 h-3.5 text-brandRed mr-1 mt-0.5 flex-shrink-0" data-id="element-453" />
                    <span data-id="element-454">{t.transition}</span>
                  </p>
                  <p className="text-xs text-gray-500 flex items-center" data-id="element-455">
                    <MapPin className="w-3 h-3 mr-1" data-id="element-456" />
                    {t.location}
                  </p>
                </div>
              </div>

              <div className="flex mb-3" data-id="element-457">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-brandGold text-brandGold" data-id="element-458" />)}
              </div>

              <p className="text-gray-700 leading-relaxed text-[15px] relative" data-id="element-459">
                "{t.quote}"
              </p>

              <div className="mt-6 pt-4 border-t border-gray-100 flex items-center justify-between" data-id="element-460">
                <span className="text-xs text-gray-500 font-medium uppercase tracking-wider" data-id="element-461">
                  Compra verificada
                </span>
                <span className="text-xs text-green-600 font-bold flex items-center" data-id="element-462">
                  <span className="w-2 h-2 bg-green-500 rounded-full mr-1.5" data-id="element-463" />
                  Cliente real
                </span>
              </div>
            </article>)}
        </div>

        <div className="text-center mt-12" data-id="element-464">
          <p className="text-gray-600 italic" data-id="element-465">
            Tu historia puede ser la próxima.
          </p>
        </div>
      </div>
    </section>;
}